<template>
    <div class="row" v-if="loaded === true">
        <!--
        <div class="col-12">
            <show-order :order="dispute.order"></show-order>
        </div>
        -->
        <div class="col-12 col-md-4 col-lg-3">
            <table class="table table-sm">
                <tr>
                    <td>{{ $t('dispute.about') }}</td>
                    <td>{{ dispute.about }}</td>
                </tr>
                <tr>
                    <td>{{ $t('dispute.status') }}</td>
                    <td>{{ dispute.status }}</td>
                </tr>
                <tr>
                    <td>{{ $t('dispute.created_at') }}</td>
                    <td>{{ dispute.created_at }}</td>
                </tr>
                <tr>
                    <td>{{ $t('dispute.solved_at') }}</td>
                    <td>{{ dispute.solved_at }}</td>
                </tr>
            </table>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
            <table class="table table-sm">
                <tr>
                    <!--<td>{{ $t('dispute.product.cause') }}</td>-->
                    <td>{{ $t('dispute.product.order_code') }}</td>
                    <td>{{ $t('dispute.product.wish') }}</td>
                    <!--<td>{{ $t('dispute.product.status') }}</td>-->
                    <td>{{ $t('dispute.product.pictures') }}</td>
                </tr>
                <tr v-for="(item,index) in dispute.products" :key="index">
                    <!--<td>{{ item.cause }}</td>-->
                    <td v-if="item.product != null">{{ item.product.product.order_code }}</td>
                    <td v-else>NO PRODUCT</td>
                    <td>{{ item.wish }}</td>
                    <!--<td>{{ item.status }}</td>-->
                    <td>
                        <img v-for="p in item.pictures" :key="p.url" :src="p.url" class="img-fluid">
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import ShowOrder from '../orders/Show'
export default {
    components: { ShowOrder },
    data() {
        return {
            dispute: {},
            loaded: false,
        }
    },
    props: {
        id: Number,
    },
    methods: {
        fetchDispute: function(id){
            this.loaded = false;
            axios.get('/api/disputes/'+id)
                .then((response) => {
                    this.dispute = response.data.dispute;
                    console.log(this.dispute);
                    this.loaded = true;
                });
        }
    },
    created() {
        this.fetchDispute(this.id);
    }

}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';
.img-fluid {
    height: 50px;
}
</style>

